// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2392":"c670b84735da562b","3254":"f0a799b9cb7d9c50","3662":"727973242bb33abd"}[chunkId] + ".css";
};